import { useState } from "react";
import { C, fonts } from "../theme.js";
import { SectionLabel } from "./primitives.jsx";
import { FAQS } from "../content.js";

export const FAQ = ({ accent }) => {
  const [tab, setTab] = useState("General");
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" style={{ background: C.about, padding: "140px 40px" }}>
      <div style={{ maxWidth: 980, margin: "0 auto" }}>
        <div style={{ textAlign: "center", marginBottom: 40 }}>
          <SectionLabel accent={accent}>// FAQ</SectionLabel>
          <h2
            style={{
              margin: "14px 0 0",
              fontFamily: fonts.serif,
              fontSize: "clamp(36px, 4.4vw, 56px)",
              fontWeight: 500,
              color: C.fg,
              letterSpacing: "-0.01em",
              lineHeight: 1.05,
            }}
          >
            Questions, <em style={{ color: accent, fontStyle: "italic", fontWeight: 500 }}>answered.</em>
          </h2>
        </div>

        <div
          role="tablist"
          aria-label="FAQ categories"
          style={{
            display: "flex",
            justifyContent: "center",
            gap: 4,
            marginBottom: 32,
            flexWrap: "wrap",
          }}
        >
          {Object.keys(FAQS).map((t) => (
            <button
              key={t}
              type="button"
              role="tab"
              aria-selected={tab === t}
              onClick={() => {
                setTab(t);
                setOpen(-1);
              }}
              style={{
                fontFamily: fonts.mono,
                fontSize: 11,
                letterSpacing: "0.18em",
                padding: "10px 18px",
                cursor: "pointer",
                background: tab === t ? accent : "transparent",
                color: tab === t ? "#0a0a0a" : C.body,
                border: `1px solid ${tab === t ? accent : C.border}`,
                borderRadius: 999,
              }}
            >
              {t.toUpperCase()}
            </button>
          ))}
        </div>

        <div style={{ borderTop: `1px solid ${C.border}` }}>
          {FAQS[tab].map(([q, a], i) => {
            const panelId = `faq-panel-${tab}-${i}`;
            const buttonId = `faq-button-${tab}-${i}`;
            const isOpen = open === i;
            return (
              <div key={i} style={{ borderBottom: `1px solid ${C.border}` }}>
                <button
                  id={buttonId}
                  type="button"
                  aria-expanded={isOpen}
                  aria-controls={panelId}
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  style={{
                    width: "100%",
                    textAlign: "left",
                    padding: "22px 4px",
                    background: "transparent",
                    border: "none",
                    cursor: "pointer",
                    color: C.fg,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 18,
                    fontFamily: fonts.serif,
                    fontSize: 20,
                    fontWeight: 500,
                    letterSpacing: "-0.005em",
                  }}
                >
                  <span>{q}</span>
                  <span
                    style={{
                      fontFamily: fonts.mono,
                      fontSize: 18,
                      color: accent,
                      transition: "transform 200ms",
                      transform: isOpen ? "rotate(45deg)" : "rotate(0)",
                      flexShrink: 0,
                    }}
                  >
                    +
                  </span>
                </button>
                {isOpen && (
                  <div
                    id={panelId}
                    role="region"
                    aria-labelledby={buttonId}
                    style={{
                      padding: "0 4px 22px",
                      fontFamily: fonts.sans,
                      fontSize: 15,
                      lineHeight: 1.7,
                      color: C.body,
                      maxWidth: 760,
                    }}
                  >
                    {a}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
